import { fabric } from "fabric";
import DEFINE from "../define";
import ToolBase from "../basic";
import DefineControl from '../controls';

export default class peelableSticker extends ToolBase {

    name = DEFINE.TOOLS.PEELABLE_STICKER;

    minSize = {
        width: 20,
        height: 20
    }

    stickOriginSize = {
        width: 5,
        height: 5
    }

    selectAreaSetting = {
        stroke: "green",
        strokeWidth: 0.5
    }

    stickerSetting = {
        fill: "#FFFF00"
    }

    stickerEarSetting = {
        fill: "white",
        shadowColor: "rgba(0, 0, 0, 0.5)"
    }

    selectArea = null;

    constructor(parent) {
        super(parent);
    }

    recover(object) {
        this.registerEvent(object);
        DefineControl.Instance.setDefaultControl(object, this, false);
    }

    mouseDown(o) {
        this.pointer = this.canvas.getPointer(o.e);

        this.selectArea = new fabric.Rect({
            left: this.pointer.x,
            top: this.pointer.y,
            width: this.minSize.width + this.stickOriginSize.width,
            height: this.minSize.height + this.stickOriginSize.height,
            fill: null,
            strokeWidth: this.selectAreaSetting.strokeWidth,
            stroke: this.selectAreaSetting.stroke
        });

        this.canvas.add(this.selectArea);
    }

    mouseMove(o) {
        let pointer = this.canvas.getPointer(o.e);

        if (this.selectArea != null) {
            let newWidth = pointer.x - this.selectArea.left;
            let newHeight = pointer.y - this.selectArea.top;

            if (newWidth < this.minSize.width + this.stickOriginSize.width) newWidth = this.minSize.width + this.stickOriginSize.width;
            if (newHeight < this.minSize.height + this.stickOriginSize.height) newHeight = this.minSize.height + this.stickOriginSize.height;
            if(this.selectArea.left + newWidth > this.canvas.width) {
                newWidth = this.canvas.width - this.selectArea.left - this.selectAreaSetting.strokeWidth * 4;
            }
            if(this.selectArea.top + newHeight > this.canvas.height) {
                newHeight = this.canvas.height - this.selectArea.top - this.selectAreaSetting.strokeWidth * 4;
            }

            this.selectArea.set({
                width: newWidth,
                height: newHeight
            });
            this.canvas.renderAll();
        }
    }

    mouseUp() {
        this.createPeelableSticker(this.selectArea);
        this.canvas.remove(this.selectArea);
        this.parent.proxy.changeTool(null);
        this.parent.addHistory();
    }

    createPeelableSticker() {
        let sticker = new fabric.Polygon([
            { x: 0, y: this.minSize.height },
            { x: this.minSize.width, y: 0 },
            { x: this.selectArea.width, y: 0 },
            { x: this.selectArea.width, y: this.selectArea.height },
            { x: 0, y: this.selectArea.height }
        ], {
            left: this.selectArea.left,
            top: this.selectArea.top,
            fill: this.stickerSetting.fill,
        });

        let stickerEar = new fabric.Polygon([
            { x: 0, y: this.minSize.height },
            { x: this.minSize.width, y: 0 },
            { x: this.minSize.width, y: this.minSize.height }
        ], {
            left: this.selectArea.left,
            top: this.selectArea.top,
            fill: this.stickerEarSetting.fill,
            shadow: {
                color: this.stickerEarSetting.shadowColor,
                blur: 5,
                offsetX: 1,
                offsetY: 1
            }
        });

        let group = new fabric.Group([sticker, stickerEar], {
            tag: DEFINE.TAG.PEELABLE_STICKER + new Date().getTime(),
            toolType: this.name,
            hasControls: true,
            hasBorders: true,
            perPixelTargetFind: true,
            isMousedown: false,
            lockScalingFlip: true
        });

        DefineControl.Instance.setDefaultControl(group, this, false);

        this.registerEvent(group);
        this.canvas.add(group);
    }

    playAnimate(target) {
        if (target.isPlaying) return;

        const self = this;
        let objects = target.getObjects();
        let sticker = objects[0];
        let stickerEar = objects[1];

        target.set({
            lockMovementX: true,
            lockMovementY: true,
            hasControls: false,
            hasBorders: false,
        });

        sticker.shadow = null;

        fabric.util.animate({
            startValue: 0,
            endValue: 1,
            duration: 1000,
            easing: fabric.util.ease.easeInQuart,
            onChange: function (value) {
                const originStickerWidth = self.minSize.width / target.scaleX;
                const originStickerHeight = self.minSize.height / target.scaleY;
                const stickerX = originStickerWidth + Math.max(0, (target.width * value - originStickerWidth));
                const stickerY = originStickerHeight + Math.max(0, (target.height * value - originStickerHeight));

                target.isPlaying = true;

                sticker.set({
                    points: [
                        { x: 0, y: stickerY },
                        { x: stickerX, y: 0 },
                        { x: target.width, y: 0 },
                        { x: target.width, y: target.height },
                        { x: 0, y: target.height },
                    ]
                })

                stickerEar.set({
                    points: [
                        { x: 0, y: stickerY },
                        { x: stickerX, y: 0 },
                        { x: stickerX, y: stickerY },
                    ],
                    shadow: {
                        blur: Math.min(2, 5 * (1 - value)),
                    }
                })

                self.canvas.renderAndResetBound();
            },
            onComplete: function () {
                self.canvas.remove(target);
                self.canvas.renderAll();
            }
        }, 100);

        this.canvas.discardActiveObject(target).renderAll()
    }

    registerEvent(group) {
        group.on("mousedown", (e) => {
            if(!e.transform) return;
            e.target.isMousedown = true;
            
            if (e.transform.offsetX < this.minSize.width && e.transform.offsetY < this.minSize.height) {
                this.canvas.discardActiveObject(group).renderAll();
            }
        });

        group.on("mousemove", (e) => {
            e.target.isMousedown = false;
        });

        group.on("mouseup", (e) => {
            if (e.target.isMousedown) {
                if (e.transform.offsetX < this.minSize.width && e.transform.offsetY < this.minSize.height) {
                    this.playAnimate(group);
                }
            }
            e.target.isMousedown = false;
        })

        group.on("scaling", (e) => {
            const groupObjs = group.getObjects();

            console.log("group left::", group.left);
            if(group.left < 0) {
                group.left = 0;
                group.scaleX = group.preScaleX;
            }
            if(group.top < 0) {
                group.top = 0;
                group.scaleY = group.preScaleY;
            }

            if(group.left + group.width * group.scaleX > this.canvas.width) {
                group.scaleX = (this.canvas.width - group.left) / group.width;
            }
            
            if(group.top + group.height * group.scaleY > this.canvas.height) {
                group.scaleY = (this.canvas.height - group.top) / group.height;
            }

            group.preScaleX = group.scaleX;
            group.preScaleY = group.scaleY;

            group.scaleX = Math.max((this.minSize.width + this.stickOriginSize.width) / group.width, group.scaleX);
            group.scaleY = Math.max((this.minSize.height + this.stickOriginSize.height) / group.height, group.scaleY);

            let backgroundStartPoints = groupObjs[0].points;
            backgroundStartPoints[0].y = this.minSize.height / group.scaleY;
            backgroundStartPoints[1].x = this.minSize.width / group.scaleX;

            let earStartObj = groupObjs[1];
            let earStartPoints = earStartObj.points;
            earStartPoints[0].y = this.minSize.height / group.scaleY;
            earStartPoints[1].x = this.minSize.width / group.scaleX;
            earStartPoints[2].x = this.minSize.width / group.scaleX;
            earStartPoints[2].y = this.minSize.height / group.scaleY;

            this.canvas.renderAll();
        })

        group.on("moving", (e) => {
            if(group.left < 0) {
                group.left = 0;
            }
            if(group.left + group.width * group.scaleX > this.canvas.width) {
                group.left = this.canvas.width - group.width * group.scaleX;
            }
            if(group.top < 0) {
                group.top = 0;
            }
            if(group.top + group.height * group.scaleY > this.canvas.height) {
                group.top = this.canvas.height - group.height * group.scaleY;
            }
        })
    }
}